export default __webpack_public_path__ + "b88f6f28c9dd7809a41522d37ce14c31.png";